/*!
 * (C) Larva.io http://larva.io - Seee LICENSE.md
 */
import { c as configFromSession, a as configFromURL, b as config, s as saveConfig } from './config-4a957d4d.js';

function appGlobalScript () {
  const win = typeof window !== 'undefined' ? window : {};
  const Larva = (win.Larva = win.Larva || {});
  // create the Larva.config from raw config object (if it exists)
  // and convert Larva.config into a ConfigApi that has a get() fn
  const configObj = Object.assign(Object.assign(Object.assign(Object.assign({}, configFromSession(win)), { persistConfig: false }), Larva.config), configFromURL(win));
  config.reset(configObj);
  if (config.getBoolean('persistConfig')) {
    saveConfig(win, configObj);
  }
  Larva.config = config;
}

const globalScripts = appGlobalScript;

export { globalScripts as g };

//# sourceMappingURL=app-globals-4e12c37a.js.map